import router from '@/router'
import store from '@/store'
import Config from '@/settings'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { filterAsyncRouter } from '@/store/modules/permission'

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/login']// no redirect whitelist

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - ' + Config.title
  }
  NProgress.start()
  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (!store.getters.role) {
        // 修改成false，防止死循环
        store.dispatch('updateLoaded')
        store.dispatch('GetUserInfo').then(() => {
          // 动态路由，拉取菜单
          loadMenu(next, to)
        }).catch(() => {
          store.dispatch('LogOut').then(() => {
            location.reload()
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next() // 在免登录白名单，直接进入
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

export const loadMenu = (next, to) => {
  const menus = store.getters.menus
  const sidebarRoutes = filterAsyncRouter(JSON.parse(JSON.stringify(menus)))
  const rewriteRoutes = filterAsyncRouter(JSON.parse(JSON.stringify(menus)), true)
  rewriteRoutes.push({
    path: '*',
    redirect: '/',
    hidden: true
  })

  store.dispatch('GenerateRoutes', rewriteRoutes).then(() => { // 存储路由
    router.addRoutes(rewriteRoutes) // 动态添加可访问路由表
    next({
      ...to,
      replace: true
    })
  })
  store.dispatch('SetSidebarRouters', sidebarRoutes)
}

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
